'use client'

import { ListItemButton, ListItemText } from '@mui/material'
import { useQueryClient } from '@tanstack/react-query'
import { usePathname, useRouter } from 'next/navigation'

import useAuth from '../../hooks/useAuth'
import { navigateToBrandPortal } from '../../lib/crossDomainAuth'
import { UsersApi } from '../../services'

type Props = { isCollapsed: boolean }

/**
 * Wysehub sidebar: switch to Ai Claims when user has both brands.
 * Ai Claims shell renders its own switch back to Wysehub.
 */
export default function BrandSwitcher({ isCollapsed }: Props) {
  const { user } = useAuth()
  const router = useRouter()
  const pathname = usePathname() || ''
  const queryClient = useQueryClient()

  if (!user || user.brandAccess !== 'both') return null
  if (pathname.startsWith('/aiclaims')) return null

  const goAiClaims = async () => {
    navigateToBrandPortal('aiclaims', '/aiclaims/welcome', async () => {
      await new UsersApi().usersSetActiveBrandMe({
        requestBody: { activeBrand: 'aiclaims' },
      })
      await queryClient.invalidateQueries({ queryKey: ['currentUser'] })
      router.push('/aiclaims/welcome')
    })
  }

  if (isCollapsed) return null

  return (
    <ListItemButton onClick={() => void goAiClaims()} sx={{ py: 0.5 }}>
      <ListItemText primary="Switch to Ai Claims" />
    </ListItemButton>
  )
}
